// Written in this round about way for babel-transform-imports
import Router from 'react-router/es/Router';

export default Router;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/Router.js
// module id = 279
// module chunks = 26 27 29